import { ContentBlock } from './lib/content-block.js';
customElements.define('cipublic-content-block', ContentBlock);
//# sourceMappingURL=cipublic-content-block.js.map